<template>
  <div class="unbundled-results" id="searchByScheduleTabContent" data-test="searchByScheduleTabContent">
    <b-tabs v-model="activeTab" v-if="!isOneWay">
      <b-tab-item
        :label="journeyLabel(index)"
        v-for="(journeyItems, index) in groupedByJourney"
        :key="index"
        :disabled="index == 1 ? false : disabledTab"
      >
        <JourneyGroup
          @unbundledJourneySelected="unbundledJourneySelected"
          @searchTargetedAirlines="
            (airlines) => $emit('searchTargetedAirlines', airlines)
          "
          :journeyLabel="journeyLabel(index)"
          :tripVal="tripVal"
          :segmentIndex="index"
          :journeyItems="journeyItems"
          :items="items"
          :groupedByJourney="groupedByJourney"
          :itineraryPrices="itineraryPrices(items)"
          data-test="journey-groups"
        />
      </b-tab-item>
      <b-tab-item label="Summary" :disabled="disabledTab">
        <div v-if="selectedItem.journeys.length === 0">
          No selected item to show.
        </div>
        <div v-else>
          <SearchByScheduleSummary :solution="selectedItem" />
        </div>
      </b-tab-item>
    </b-tabs>
    <!-- ONE-WAY -->
    <div v-else>
      <div v-for="(journeyItems, index) in groupedByJourney" :key="index">
        <JourneyGroup
          @unbundledJourneySelected="unbundledJourneySelected"
          @searchTargetedAirlines="
            (airlines) => $emit('searchTargetedAirlines', airlines)
          "
          :journeyLabel="journeyLabel(index)"
          :segmentIndex="index"
          :journeyItems="journeyItems"
          :items="items"
          :groupedByJourney="groupedByJourney"
          :itineraryPrices="itineraryPrices(items)"          
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import bookingMixin from "@/mixins/bookingMixin";
import JourneyGroup from "./JourneyGroup.vue";
import SearchByScheduleSummary from "./SearchByScheduleSummary.vue";
import { mapState } from "vuex";
import { eventBus } from "../../../main";

export default {
  mixins: [bookingMixin],
  components: {
    JourneyGroup,
    SearchByScheduleSummary,
  },
  props: {
    items: {},
    formData: Object,
  },
  data() {
    return {
      activeTab: 0,
      disabledTab: true,
    };
  },
  computed: {
    ...mapState(["bookTravel"]),
    ...mapState(["travellersAndTrips"]),
    travellerProfile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
    expectedUnbundledJourneysCount() {
      return this.$store.getters[
        "bookTravel/getExpectedUnbundledJourneysCount"
      ];
    },
    tripVal() {
      return this.formData.tripVal;
    },
    /*
    selectedItem() {
      let items = this.items;
      let solution = { journeys: []};
      let selectedUnbundledJourneys = this.bookTravel.selectedUnbundledJourneys;

      // Build the uniqueKey for the entire solution that is selected
      let selectedUnbundledJourneysUniqueKey = Object.values(
        selectedUnbundledJourneys
      ).join("|");

      let matchingItem = items.find((item) => {
        return item.uniqueKey == selectedUnbundledJourneysUniqueKey;
      });



      if (matchingItem) {
        solution = matchingItem;
      }

      return solution;

    },
    */

    //find proposed flight items that include all of the selected journeys
    matchingItems() {
      let items = this.items;
      let selectedUnbundledJourneys = this.bookTravel.selectedUnbundledJourneys;

      //convert to array
      let currentJourneys = Object.values(selectedUnbundledJourneys);

      //look for matching flight result that contains all of the selected journeys
      let matchingItems = items.filter((item) => {
        return currentJourneys.every((journey) => {
          let itemJourneys = item.journeys.map((journey) => journey.uniqueKey);

          return itemJourneys.includes(journey);
        });
      });

      return matchingItems;
    },

    //if we have definitive flight item return it here, else return solution obj with empty array
    selectedItem() {
      let solution = { journeys: [] };

      if (this.matchingItems.length == 1) {
        solution = this.matchingItems[0];
      }

      return solution;
    },

    groupedByJourney() {
      // All the items
      let items = this.items;
      // Track unique items by uniqueKey
      let uniqueItems = {};
      // Store unique items grouped by journey
      let itemsByJourney = {};
      // Loop through each recommendation
      for (let item of items) {
        // Loop through each recommendation's journeys
        for (let journey of item.journeys) {
          let uniqueKey = journey.uniqueKey;
          let segmentIndex = journey.segmentIndex;

          // Create the property for the journey if it doesn't exist
          if (itemsByJourney[segmentIndex] === undefined) {
            itemsByJourney[segmentIndex] = [];
            uniqueItems[segmentIndex] = [];

            // console.log('create itemsByJourney value for segment: ' + segmentIndex)
          }

          // Check if we have already seen this uniqueKey
          if (uniqueItems[uniqueKey] === undefined) {
            // Add to list so we can skip it next time we see it
            uniqueItems[uniqueKey] = 1;

            // Add to list of items for the journey
            itemsByJourney[segmentIndex].push(journey);
          } else {
            uniqueItems[uniqueKey]++;
          }
        }
      }
      let journeysCount = Object.keys(itemsByJourney).length;
      this.$store.commit(
        "bookTravel/SET_EXPECTED_UNBUNDLED_JOURNEYS_COUNT",
        journeysCount
      );
      // console.log('itemsByJourney', itemsByJourney);
      return itemsByJourney;
    },
  },
  methods: {
    unbundledJourneySelected(payload) {
      // console.log('unbundledJourneySelected > UnbundledResults: ' + payload.segmentIndex)
      this.activateNextTab(payload);
    },
    activateNextTab(payload) {
      //console.log('activateNextTab: ' + payload.segmentIndex);
      this.activeTab = parseInt(payload.segmentIndex);
      this.disabledTab = false;

      // load more results for selected outbound flight
      if (payload.segmentIndex == 1) {
        this.loadMoreItems(payload);
      }
    },
    //perform anchored search
    loadMoreItems(payload) {
      if (payload.journey.legs.length > 0) {
        let runNewApiSearch = true;
        let lastApiSearchTime = this.$store.getters[
          "bookTravel/getAnchoredSearchTime"
        ](payload.journey.uniqueKey);

        if (lastApiSearchTime !== null) {
          //Check time of last anchored search and see if it has expired

          //console.log (lastApiSearchTime);
          let searchExpirationTime =
            lastApiSearchTime + this.$appConfig.timeRefresh;
          //console.log(searchExpirationTime);

          if (Date.now() > searchExpirationTime) {
            runNewApiSearch = true;
            //console.log("previous anchored search expired");
          } else {
            runNewApiSearch = false;
            //console.log("previous anchored search still ok");
          }
        }

        // make a new API call
        if (runNewApiSearch) {
          this.$store.commit("bookTravel/FLIGHT_SEARCH_LOADING_STATUS", true);
          this.$store.commit("bookTravel/FLIGHT_SEARCH_COMPLETE", false);

          // build a search object
          let anchoredSearch = {
            travelerId: this.travellerProfile.id,
            numberOfPassengers: 1,
            numberOfResults: 200,
            itinerary: [
              {
                departureLocation: {
                  airport: this.formData.loc1.code,
                },
                arrivalLocation: {
                  airport: this.formData.loc2.code,
                },
                date: {
                  date: moment(this.formData.startDate.date).format(
                    "YYYY-MM-DD"
                  ),
                },
                anchoredSegments: [],
              },
              {
                departureLocation: {
                  airport: this.formData.loc2.code,
                },
                arrivalLocation: {
                  airport: this.formData.loc1.code,
                },
                date: {
                  date: moment(this.formData.endDate.date).format("YYYY-MM-DD"),
                },
              },
            ],
          };

          if (this.formData.startDate.advanced.tod !== "Anytime") {
            anchoredSearch.itinerary[0].date = this.setAdvancedDateTime(
              this.formData.startDate
            );
          }

          if (this.formData.endDate.advanced.tod !== "Anytime") {
            anchoredSearch.itinerary[1].date = this.setAdvancedDateTime(
              this.formData.endDate
            );
          }

          if (this.formData.cabinClass) {
            anchoredSearch.cabinClass = this.formData.cabinClass;
          }

          let anchoredSegments = [];

          for (let leg of payload.journey.legs) {
            anchoredSegments.push({
              departureDate: {
                date: moment(leg.departingAt.date).format("YYYY-MM-DD"),
                time: leg.departingAt.time,
              },
              arrivalDate: {
                date: moment(leg.arrivingAt.date).format("YYYY-MM-DD"),
                time: leg.arrivingAt.time,
              },
              departureAirport: leg.departingAirport,
              arrivalAirport: leg.arrivingAirport,
              airlineCode:
                leg.operatingAirline.code !== null
                  ? leg.operatingAirline.code
                  : payload.journey.airlineCode,
              flightNumber: leg.flightNumber,
            });
          }
          anchoredSearch.itinerary[0].anchoredSegments = anchoredSegments;
          // console.log('anchoredSearch', anchoredSearch);

          if (
            this.$store.getters["travellersAndTrips/getTravellers"].tripType ===
            "business"
          ) {
            anchoredSearch.travelPolicyId = this.travellerProfile.travelPolicyId;
            anchoredSearch.applyPolicy = true;
          }

          this.$app
            .huddleLabsServerCall("amadeus/air/search", anchoredSearch)
            .then((result) => {
              this.error = result.errors;

              if (!this.error) {
                if (result.data.length > 0) {
                  this.$emit("appendResults", result.data);

                  /*
                      // add items to localStorage
                      let newItems = {
                        uniqueKey: payload.journey.uniqueKey,
                        items: result.data,
                      }
                      this.$store.commit('bookTravel/ADD_SEARCH_BY_SCHEDULE_FLIGHTS', newItems);
                      */

                  //store the time of this search
                  let timer = {
                    uniqueKey: payload.journey.uniqueKey,
                    time: Date.now(),
                  };
                  this.$store.commit(
                    "bookTravel/SET_ANCHORED_SEARCH_TIMER",
                    timer
                  );
                }
              }

              this.$store.commit(
                "bookTravel/FLIGHT_SEARCH_LOADING_STATUS",
                false
              );
              this.$store.commit("bookTravel/FLIGHT_SEARCH_COMPLETE", true);
            });
        }
      }
    },
    setAdvancedDateTime(obj) {
      console.dir('set adv date');

      let date = {
        date: moment(obj.date).format("YYYY-MM-DD"),
        time: null,
        timeWindow: 4,
        isDeparture: obj.advanced.isDeparture, //.toString(),
      };

      if (obj.advanced.tod == "Morning") {
        date.time = "8:00";
      }

      if (obj.advanced.tod == "Afternoon") {
        date.time = "13:00";
      }

      if (obj.advanced.tod == "Evening") {
        date.time = "18:00";
      }

      if (obj.advanced.tod == "Custom") {
        date.time = moment(obj.advanced.time).format("HH:mm");
        date.timeWindow = obj.advanced.hours;
      }

      return date;
    },
    itineraryPrices(items) {
      let priceMap = [];
      // Loop through each recommendation
      for (let item of items) {
        let priceMapItem = {
          id: item.id,
          pricing: item.pricing,
          journeys: [],
        };
        // Loop through each recommendation's journeys
        for (let journey of item.journeys) {
          priceMapItem.journeys.push(journey.uniqueKey);
        }
        priceMap.push(priceMapItem);
      }

      return priceMap;
    },
  },
  mounted() {
    eventBus.$on("unselect-journey", (data) => {
      // console.log('listen to event bus: ', data);
      if (data == 1) {
        this.activateNextTab({ segmentIndex: 0 });
        this.disabledTab = true;
      } else {
        console.warn("Listen to $eventBus: ", data);
        this.disabledTab = false;
      }
    });
  },
  updated() {
    // console.log('this.selectedItem', this.selectedItem);
  },
};
</script>

<style scoped></style>
